import type { FC } from 'react';

import { CustomTable } from 'components/table/style';
import { Table, Typography, openModal } from 'enable-ui';

import { MODAL_KEY } from 'modules/auth/core/modal-key';
import type { Exercises } from 'modules/dashboard/core/type';

import { ReactComponent as VideoIcon } from 'assets/icons/video.svg';

import { COLOR } from 'constants/color';

export const LessonExercises: FC<{
  columns: any[];
  data: Exercises[];
  levels: number[];
  setIndex: (index: number) => void;
  setLevel: (level: number) => void;
  isSupervised: boolean;
}> = ({ columns, data, levels, setIndex, setLevel, isSupervised }) => {
  return (
    <>
      {/* <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: '12px' }}>
        <Typography weight={700}>Exercises</Typography>
        <Tooltip content="" arrow="false">
          <InfoIcon />
        </Tooltip>
      </div> */}
      <CustomTable $isShowBorder={false}>
        {levels.map((level, index) => (
          <div
            key={level}
            style={{
              border: `1px solid ${COLOR.neutralTrans['neutralTrans-25']}`,
              borderRadius: '12px',
              marginBottom: index === levels.length - 1 ? 0 : 16,
            }}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                padding: '12px 36px 12px 16px',
                borderBottom: `1px solid ${COLOR.neutralTrans['neutralTrans-25']}`,
              }}
            >
              <Typography weight={700}>Level {level}</Typography>
              {isSupervised && (
                <div
                  style={{ display: 'flex', justifyContent: 'center', cursor: 'pointer' }}
                  onClick={() => {
                    openModal(MODAL_KEY.SHOW_VIDEO);
                    setIndex(0);
                    setLevel(level);
                  }}
                >
                  <VideoIcon />
                </div>
              )}
            </div>
            <div className="table-levels-lessons-wrapper">
              <Table
                columns={columns}
                dataSource={data.filter((el) => el?.level === level)}
                total={0}
                tableKey={''}
                queryState={{ page: 1, limit: 9999 }}
                paginationConfigs={{
                  show: false,
                }}
              />
            </div>
          </div>
        ))}
      </CustomTable>
    </>
  );
};
